__turbopack_context__.v({
  "upgrade-button": "UpgradeButton-module-scss-module__GXL8XW__upgrade-button",
});
